<script>
import { layoutMethods, languageMethods } from "@/state/helpers";
import img1 from "../assets/images/products/img-1.png";
import img2 from "../assets/images/products/img-2.png";
import img3 from "../assets/images/products/img-3.png";
import img4 from "../assets/images/products/img-6.png";
import img5 from "../assets/images/products/img-5.png";

import simplebar from "simplebar-vue";

import i18n from "../i18n";
import { decodeJwtTokenPayload } from "../helpers/jwtHelper";
import { toast } from "vue3-toastify";

import AppNavBarService from "@/services/AppNavbar/appNavBarService";
import ImpersonateIslemService from "@/services/ImpersonateIslemService";
import { routeAndMenuComputed, routeMethods } from "../state/helpers";


const appNavBarService = new AppNavBarService();
const impersoneteIslemService = new ImpersonateIslemService();

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      userFullName: "",
      userFirstName: "",
      activeRole: "",
      dosya: `${require("@/assets/images/avatar/14-small.png")}`,
      isImpersonate: false,
      impId: 0,
      isProxyRole: false,
      roleInfos: [],
      proxyRoleInfos: [],
      ProxySicilNo: "",
      searchResult: [],
      routes: [],
      roleName: "",
      menuItems: [],
      cartItems: [
        {
          id: 1,
          productImage: img1,
          productName: "Branded T-Shirts",
          productLink: "/ecommerce/product-details",
          quantity: "10 x $32",
          itemPrice: "320",
        },
        {
          id: 2,
          productImage: img2,
          productName: "Bentwood Chair",
          productLink: "/ecommerce/product-details",
          quantity: "5 x $18",
          itemPrice: "89",
        },
        {
          id: 3,
          productImage: img3,
          productName: "Borosil Paper Cup",
          productLink: "/ecommerce/product-details",
          quantity: "3 x $250",
          itemPrice: "750",
        },
        {
          id: 4,
          productImage: img4,
          productName: "Gray Styled T-Shirt",
          productLink: "/ecommerce/product-details",
          quantity: "1 x $1250",
          itemPrice: "1250",
        },
        {
          id: 5,
          productImage: img5,
          productName: "Stillbird Helmet",
          productLink: "/ecommerce/product-details",
          quantity: "2 x $495",
          itemPrice: "990",
        },
      ],

      languages: [
        {
          flag: require("@/assets/images/flags/us.svg"),
          language: "en",
          title: "English",
        },
        // {
        //   flag: require("@/assets/images/flags/spain.svg"),
        //   language: "sp",
        //   title: "Española",
        // },
        // {
        //   flag: require("@/assets/images/flags/germany.svg"),
        //   language: "gr",
        //   title: "Deutsche",
        // },
        // {
        //   flag: require("@/assets/images/flags/italy.svg"),
        //   language: "it",
        //   title: "italiana",
        // },
        // {
        //   flag: require("@/assets/images/flags/russia.svg"),
        //   language: "ru",
        //   title: "русский",
        // },
        // {
        //   flag: require("@/assets/images/flags/china.svg"),
        //   language: "ch",
        //   title: "中國人",
        // },
        // {
        //   flag: require("@/assets/images/flags/french.svg"),
        //   language: "fr",
        //   title: "Français",
        // },
        // {
        //   flag: require("@/assets/images/flags/ae.svg"),
        //   language: "ar",
        //   title: "Arabic",
        // },
        {
          flag: require("@/assets/images/flags/tr.svg"),
          language: "tr",
          title: "Türkçe",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      myVar: 1,
      developmentWarnShow: false,
    };
  },
  components: {
    simplebar,
  },
  methods: {
    ...layoutMethods,
    ...languageMethods,
    ...routeMethods,
    onRoutechange() {
      this.viewPersonel();
    },
    //...mapMutations('app',['setLanguageMut']),
    async viewPersonel() {
      if (
        this.dosya == `${require("@/assets/images/avatar/14-small.png")}` &&
        this.$router.currentRoute._value.meta.authRequired
      ) {
        let response = await appNavBarService.GetPersonelPhoto();
        if (response.length > 28) {
          this.dosya = response;
        }
      }
    },
    async viewOgrenci() {
      this.dosya = "";
      let response = await appNavBarService.GetOgrenciPhoto();
      if (response.length > 28) {
        this.dosya = response;
      } else {
        this.dosya = `${require("@/assets/images/avatar/14-small.png")}`;
      }
    },
    redirectToProfil() {
      window.location.href = "https://profil.atilim.edu.tr";
    },
    redirectToAtacs() {
      window.location.href = process.env.VUE_APP_ATACS_STAFF_URL;
    },
    redirectToPosta() {
      let loggedUserInfo = decodeJwtTokenPayload(localStorage.getItem("token"));
      let Ogrenci = loggedUserInfo.Ogrenci;

      if (Ogrenci === "null") {
        window.location.href = "https://posta.atilim.edu.tr";
      } else {
        window.location.href = "https://student.atilim.edu.tr";
      }
    },
    async logout(event) {
      event.preventDefault();
      localStorage.clear();
      window.location.replace(
        `${process.env.VUE_APP_BACKEND_URL}/api/Identity/Auth/Logout`
      );
    },
    async Impersonatelogut() {
      this.result = await impersoneteIslemService.logout();
      let token = this.result.data.responseData;

      localStorage.setItem("token", token);
      window.location.replace(`/ana-sayfa`);
    },

    async switchUserRole(event, roleObject, tur) {
      event.preventDefault();
      let result = "";
      if (tur === 1) {
        let roleModel = {
          IsProxy: roleObject.proxyRoleStatus,
          RolId: roleObject.roleId,
          ProxySicilNo: roleObject.ProxysicilNo,
          ImpId: this.impId,
        };

        result = await appNavBarService.RolDegistir(roleModel);
      } else if (tur === 2) {
        let roleModel = {
          OgrNo: roleObject.roleName,
          ImpId: this.impId,
        };
        result = await appNavBarService.OgrencilikDegistir(roleModel);
      }

      localStorage.removeItem("token");
      localStorage.removeItem("menus");
      localStorage.setItem("token", result.data.responseData);

      localStorage.setItem("currentUserRole", roleObject.roleName);
      localStorage.setItem("ActiveRolId", roleObject.roleId);
      window.location.replace(`${process.env.VUE_APP_FRONTEND_URL}/ana-sayfa`);
    },
    getMenuItems(array) {
      for (let a of array) {
        if (Array.isArray(a.children)) {
          this.getMenuItems(a.children);
        }
        if (a.route) this.menuItems.push(a);
      }
    },
    isCustomDropdown() {
      //Search bar
      let searchOptions = document.getElementById("search-close-options");
      let dropdown = document.getElementById("search-dropdown");
      let searchInput = document.getElementById("search-options");

      searchInput.addEventListener("focus", () => {
        let inputLength = searchInput.value.length;
        if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchInput.addEventListener("keyup", () => {
        let filtered = this.menuItems.map((x) => ({
          pageName: x.title,
          to: x.route,
          isShown: false,
        }));
        let filteredArr = filtered.filter(
          (o) =>
            !o.isShown &&
            Object.keys(o).some(
              (k) =>
                o[k] !== null &&
                o[k] !== undefined &&
                o[k]
                  .toString()
                  .toLowerCase()
                  .indexOf(searchInput.value.toLowerCase()) !== -1
            )
        );

        this.searchResult = filteredArr;

        let inputLength = searchInput.value.length;
        if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchOptions.addEventListener("click", () => {
        searchInput.value = "";
        dropdown.classList.remove("show");
        searchOptions.classList.add("d-none");
      });

      document.body.addEventListener("click", (e) => {
        if (e.target.getAttribute("id") !== "search-options") {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });
    },
    handleAttributes(windowSize){
      if (windowSize < 1025 && windowSize > 767) {
          document.body.classList.remove("vertical-sidebar-enable");
          document.documentElement.getAttribute("data-sidebar-size") == "sm"
            ? document.documentElement.setAttribute("data-sidebar-size", "")
            : document.documentElement.setAttribute("data-sidebar-size", "sm");
        } else if (windowSize > 1025) {
          document.body.classList.remove("vertical-sidebar-enable");
          document.documentElement.getAttribute("data-sidebar-size") == "lg"
            ? document.documentElement.setAttribute("data-sidebar-size", "sm")
            : document.documentElement.setAttribute("data-sidebar-size", "lg");
        } else if (windowSize <= 767) {
          document.body.classList.add("vertical-sidebar-enable");
          document.documentElement.setAttribute("data-sidebar-size", "lg");
        }
    },
    toggleHamburgerMenu() {
      let windowSize = document.documentElement.clientWidth;
      let layoutType = document.documentElement.getAttribute("data-layout");

      document.documentElement.setAttribute("data-sidebar-visibility", "show");
      let visiblilityType = document.documentElement.getAttribute(
        "data-sidebar-visibility"
      );

      if (windowSize > 767)
        document.querySelector(".hamburger-icon").classList.toggle("open");

      //For collapse horizontal menu
      if (
        document.documentElement.getAttribute("data-layout") === "horizontal"
      ) {
        document.body.classList.contains("menu")
          ? document.body.classList.remove("menu")
          : document.body.classList.add("menu");
      }

      //For collapse vertical menu

      if (
        visiblilityType === "show" &&
        (layoutType === "vertical" || layoutType === "semibox")
      ) {
        this.handleAttributes(windowSize);
      }

      //Two column menu
      if (document.documentElement.getAttribute("data-layout") == "twocolumn") {
        document.body.classList.contains("twocolumn-panel")
          ? document.body.classList.remove("twocolumn-panel")
          : document.body.classList.add("twocolumn-panel");
      }
    },
    showWelcomeMsg(loggedUserToken) {
      let resultUserInfo = decodeJwtTokenPayload(loggedUserToken);
      let welcomeMessageUser = resultUserInfo.FullName;

      toast.success(`Hoş Geldiniz Sn. ${welcomeMessageUser}`, {
        type: "default",
        theme: "colored",
        position: "bottom-right",
        transition: "zoom",
        autoClose: 3000,
      });
    },
    showChangeRolMsg() {
      let rol = localStorage.getItem("currentUserRole");
      toast.success(`Başarılı bir şekilde ${rol} rolüne geçiş yaptınız.`, {
        type: "default",
        theme: "colored",
        position: "bottom-right",
        transition: "zoom",
        autoClose: 3000,
      });
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        this.exitFullScreen();
      }
    },
    exitFullScreen() {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    },
    async setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      document.getElementById("header-lang-img").setAttribute("src", flag);
      i18n.global.locale = locale;
      this.setLanguageAction({ lang: locale });
      localStorage.setItem("language", locale);
      this.addRoutesAndMenuFromApi();
    },
    toggleDarkMode() {
      if (document.documentElement.getAttribute("data-bs-theme") == "dark") {
        document.documentElement.setAttribute("data-bs-theme", "light");
      } else {
        document.documentElement.setAttribute("data-bs-theme", "dark");
      }

      const mode = document.documentElement.getAttribute("data-bs-theme");
      this.changeMode({
        mode: mode,
      });
    },
    removeItem(cartItem) {
      this.cartItems = this.cartItems.filter((item) => item.id !== cartItem.id);
      this.$emit("cart-item-price", this.cartItems.length);
    },
    setProxyAndActiveRoles() {
      if (this.roleInfos.length != 0) {
        this.activeRole = this.roleInfos.find((x) => x.isActive).roleName;
        this.isProxyRole = this.roleInfos.find(
          (x) => x.isActive
        ).proxyRoleStatus;
        if (this.isProxyRole) {
          this.ProxySicilNo = this.roleInfos.find(
            (x) => x.isActive
          ).ProxysicilNo;
        }
      } else this.activeRole = "STANDARTROL";
    },
    showWelcomeOrChangeRoleMsg(loggedUserInfo, token) {
      let ilkRol = localStorage.getItem("currentUserRole");
      let sonRol = localStorage.getItem("oncekiRole");
      if (loggedUserInfo === null) {
        this.showWelcomeMsg(token);
        localStorage.setItem("oncekiRole", ilkRol);
      } else if (loggedUserInfo !== null && sonRol !== this.roleName) {
        this.showChangeRolMsg();
        localStorage.setItem("oncekiRole", ilkRol);
      }
    },
    removeSelfRole() {
      let selfRolIndex = this.roleInfos
        .map((e) => e.roleName)
        .indexOf(this.roleName);

      let hasProxyRoleStatus = this.roleInfos.some((e) => e.proxyRoleStatus);

      if (!hasProxyRoleStatus) {
        this.roleInfos.splice(selfRolIndex, 1);
      }
    },
    ogrenciArrayDoldur(resultUserInfo) {
      let generatedRoleObjectArr = [];
      this.viewOgrenci();
      let ogrenciBilgi = JSON.parse(resultUserInfo.Ogrenci);
      this.kisitur = 2;
      this.baslik = this.$t("StudentSelection");
      this.icYazi = this.$t("Yourstudentships");
      let ogrencilikler = ogrenciBilgi.Ogrencis;
      if (ogrencilikler.length > 1) {
        this.changeButtonVisible = true;
      }

      this.roleName = ogrencilikler.find((o) => o.IsActive === true).OgrNo;

      for (const element of ogrencilikler) {
        generatedRoleObjectArr.push({
          roleId: ogrenciBilgi.RolId,
          roleName: element.OgrNo,
          birimId: element.BirimId,
          isActive: element.IsActive,
          ProxysicilNo: element.OgrencilikAdi,
        });
      }
      return generatedRoleObjectArr;
    },
    personelArrayDoldur(resultUserInfo) {
      let generatedRoleObjectArr = [];
      this.viewPersonel();

      this.kisitur = 1;
      this.baslik = this.$t("RoleSelection");
      this.icYazi = this.$t("Yourroles");

      let personelbilgi = JSON.parse(resultUserInfo.Personel);

      let roles = personelbilgi.Roles;
      if (roles.length > 2) {
        this.changeButtonVisible = true;
      }
      let currentRole = roles.find((o) => o.IsActive === true);
      this.roleName = currentRole.RoleName;

      let tobespliced = true;

      let proxyvarmi = roles.some((item) => item.IsProxy === true);
      if (proxyvarmi) {
        let proxyharicroles = roles.filter((item) => item.IsProxy !== true);
        if (proxyharicroles.length === 1) {
          if (proxyharicroles[0].RoleId === 388) {
            this.changeButtonVisible = true;
            tobespliced = false;
          }
        }
      }

      if (tobespliced) {
        let standartrolindex = roles.map((e) => e.RoleId).indexOf(388);
        roles.splice(standartrolindex, 1);
      }

      for (const element of roles) {
        generatedRoleObjectArr.push({
          roleId: element.RoleId,
          roleName: element.RoleName,
          proxyRoleStatus: element.IsProxy,
          ProxysicilNo: element.SicilNo,
          birimId: element.BirimIds,
          isActive: element.IsActive,
          sicilNo: personelbilgi.SicilNo,
        });
      }
      return generatedRoleObjectArr;
    },
  },
  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
    menus(newValue) {
      const clearButton = document.getElementById("search-close-options");
      if (clearButton) {
        clearButton.click();
      }
      if (newValue) {
        this.menuItems = [];
        this.getMenuItems(JSON.parse(newValue));
      }
    },
  },

  computed: {
    ...routeAndMenuComputed,
    calculateTotalPrice() {
      return this.cartItems
        .reduce((total, item) => total + parseFloat(item.itemPrice), 0)
        .toFixed(2);
    },
    icYazi() {
      return this.kisitur === 1
        ? this.$t("Yourroles")
        : this.$t("Yourstudentships");
    },
  },
  mounted() {
    let dil = localStorage.getItem("language");
    if (dil === null) {
      dil = "tr";
    }
    this.flag = dil;
    this.languages.forEach((item) => {
      if (item.language == this.flag) {
        document
          .getElementById("header-lang-img")
          .setAttribute("src", item.flag);
      }
    });

    document.addEventListener("scroll", function () {
      let pageTopbar = document.getElementById("page-topbar");
      if (pageTopbar) {
        document.body.scrollTop >= 50 ||
        document.documentElement.scrollTop >= 50
          ? pageTopbar.classList.add("topbar-shadow")
          : pageTopbar.classList.remove("topbar-shadow");
      }
    });
    if (document.getElementById("topnav-hamburger-icon"))
      document
        .getElementById("topnav-hamburger-icon")
        .addEventListener("click", this.toggleHamburgerMenu);

    this.isCustomDropdown();
  },
  created() {
    if (process.env.VUE_APP_FRONTEND_URL !== "https://unacs.atilim.edu.tr")
      this.developmentWarnShow = true;
    this.menuItems = [];
    let token = localStorage.getItem("token");
    if (token) {
      //ilk başta token olmadığında patlamasın diye değiştirildi.
      if (this.menus.length > 0) this.getMenuItems(JSON.parse(this.menus));
      let resultUserInfo = decodeJwtTokenPayload(token);
      this.userFullName = resultUserInfo.FullName;
      this.userFirstName = resultUserInfo.FirstName;
      let loggedUserInfo = localStorage.getItem("isLoggedUser");
      this.isImpersonate = resultUserInfo.ImpID != 0;
      let generatedRoleObjectArr = [];

      this.impId = resultUserInfo.ImpID;
      let Ogrenci = resultUserInfo.Ogrenci;

      if (Ogrenci === "null") {
        generatedRoleObjectArr = this.personelArrayDoldur(resultUserInfo);
      } else {
        generatedRoleObjectArr = this.ogrenciArrayDoldur(resultUserInfo);
      }

      this.roleInfos = generatedRoleObjectArr;

      this.setProxyAndActiveRoles();

      localStorage.setItem("currentUserRole", this.roleName);
      localStorage.setItem("isLoggedUser", true);

      this.showWelcomeOrChangeRoleMsg(loggedUserInfo, token);
      this.currentUserRoleName = this.roleName;
      this.removeSelfRole();
    }
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="layout-width">
      <div class="navbar-header">
        <div class="d-flex">
          <!-- LOGO -->
          <div class="navbar-brand-box horizontal-logo">
            <router-link to="/" class="logo logo-dark">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span class="logo-lg">
                <img src="@/assets/images/logo-dark.png" alt="" height="17" />
              </span>
              <span
                class="text-danger ml-1"
                v-if="developmentWarnShow === true"
              >
                {{ $t("DevelopmentEnvWarnText") }}
              </span>
            </router-link>

            <router-link to="/" class="logo logo-light">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span class="logo-lg">
                <img src="@/assets/images/logo-light.png" alt="" height="17" />
              </span>
              <span v-if="developmentWarnShow === true">
                {{ $t("DevelopmentEnvWarnText") }}
              </span>
            </router-link>
          </div>

          <BButton
            variant="white"
            class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
            id="topnav-hamburger-icon"
          >
            <span class="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </BButton>

          <!-- App Search-->
          <form class="app-search d-none d-md-block">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                :placeholder="$t('MenuSearchPlaceHolderText')"
                autocomplete="off"
                id="search-options"
                value=""
              />
              <span class="mdi mdi-magnify search-widget-icon"></span>
              <span
                class="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                id="search-close-options"
              ></span>
            </div>
            <div class="dropdown-menu dropdown-menu-lg" id="search-dropdown">
              <simplebar data-simplebar style="max-height: 320px">
                <div class="dropdown-header mt-2">
                  <h6 class="text-overflow text-muted mb-1 text-uppercase">
                    Pages
                  </h6>
                </div>

                <b-link
                  v-for="searchitem in searchResult"
                  :key="searchitem"
                  href="javascript:void(0);"
                  class="dropdown-item notify-item"
                >
                  <router-link :to="searchitem.to"
                    >{{ searchitem.pageName }}
                    <i class="ri-arrow-right-line ms-1"></i
                  ></router-link>
                </b-link>
              </simplebar>
            </div>
          </form>
        </div>

        <div class="d-flex align-items-center">
          <BButton @click="redirectToAtacs()" class="btn btn-light">{{
            $t("GoToAtacs")
          }}</BButton>
          <BDropdown
            class="dropdown"
            variant="ghost-secondary"
            dropstart
            :offset="{ alignmentAxis: 55, crossAxis: 15, mainAxis: -50 }"
            toggle-class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle arrow-none"
            menu-class="dropdown-menu-end"
          >
            <template #button-content>
              <img
                id="header-lang-img"
                src="@/assets/images/flags/us.svg"
                alt="Header Language"
                height="20"
                class="rounded"
              />
            </template>
            <b-link
              href="javascript:void(0);"
              class="dropdown-item notify-item language py-2"
              v-for="(entry, key) in languages"
              :data-lang="entry.language"
              :title="entry.title"
              @click="setLanguage(entry.language, entry.title, entry.flag)"
              :key="key"
            >
              <img :src="entry.flag" alt="" class="me-2 rounded" height="18" />
              <span class="align-middle">{{ entry.title }}</span>
            </b-link>
          </BDropdown>

          <BDropdown
            text="Rol Seçimi"
            data-bs-toggle="tooltip"
            class="dropdown"
            variant="ghost-secondary"
            v-if="changeButtonVisible"
            dropstart
            :offset="{ alignmentAxis: 55, crossAxis: 15, mainAxis: -50 }"
            toggleClass="arrow-none"
            menu-class="dropdown-menu-end"
          >
            <template #button-content>
              <div style="display: flex; align-items: center; gap: 8px">
                <span class="user-name-sub-text">{{
                  $t("RoleSelection")
                }}</span>
                <font-awesome-icon
                  class="user-name-sub-text"
                  icon="fa fa-refresh"
                />
              </div>
            </template>
            <div
              class="p-3 border-top-0 border-start-0 dropdown-head border-end-0 border-dashed border dropdown-menu-md"
            >
              <BRow class="align-items-center">
                <BCol>
                  <h6 class="m-0 fs-16 fw-semibold">{{ icYazi }}</h6>
                </BCol>
              </BRow>
              <br />
              <div
                class="d-block dropdown-item dropdown-item-cart text-wrap py-2"
                v-for="roleInfo in roleInfos"
                :key="roleInfo.roleId"
              >
                <div>
                  <div>
                    <b-link>
                      <BMedia>
                        <BRow>
                          <BCol cols="1">
                            <font-awesome-icon icon="fa fa-refresh" />
                          </BCol>
                          <BCol>
                            <h6
                              class="mt-0 mb-1"
                              @click="switchUserRole($event, roleInfo, kisitur)"
                            >
                              <a class="font-weight-bolder">
                                {{ roleInfo.roleName }}
                              </a>
                              <span
                                v-if="roleInfo.proxyRoleStatus"
                                class="text-danger"
                                >({{ this.$t("ProxyPageProxyText") }})</span
                              >
                              <span>{{ roleInfo.ProxysicilNo }}</span>
                            </h6>
                          </BCol>
                        </BRow>
                      </BMedia>
                    </b-link>
                  </div>
                </div>
              </div>
            </div>
          </BDropdown>

          <div class="ms-1 header-item d-none d-sm-flex">
            <BButton
              v-if="isImpersonate"
              type="button"
              variant="ghost-secondary"
              class="btn-icon btn-topbar rounded-circle light-dark-mode"
              @click="Impersonatelogut()"
            >
              <font-awesome-icon icon="fa-solid fa-people-arrows" />
            </BButton>
          </div>
          <div class="ms-1 header-item d-none d-sm-flex">
            <BButton
              type="button"
              variant="ghost-secondary"
              class="btn-icon btn-topbar rounded-circle light-dark-mode"
              @click="toggleDarkMode"
            >
              <i class="bx bx-moon fs-22"></i>
            </BButton>
          </div>
          <BDropdown
            variant="link"
            class="ms-sm-3 header-item topbar-user"
            toggle-class="rounded-circle arrow-none"
            menu-class="dropdown-menu-end"
            :offset="{ alignmentAxis: -14, crossAxis: 0, mainAxis: 0 }"
          >
            <template #button-content>
              <span class="d-flex align-items-center">
                <img
                  class="rounded-circle header-profile-user"
                  :src="dosya"
                  alt="Header Avatar"
                />
                <span class="text-start ms-xl-2">
                  <span
                    class="d-none d-xl-inline-block ms-1 fw-medium user-name-text"
                    >{{ this.userFullName }}</span
                  >
                  <span
                    class="d-none d-xl-block ms-1 fs-12 user-name-sub-text"
                    >{{ this.activeRole }}</span
                  >
                  <span
                    v-if="isProxyRole"
                    class="d-none d-xl-block ms-1 fs-12 user-name-sub-text text-danger"
                    >{{ this.$t("ProxyPageProxyText") }}
                    {{ this.ProxySicilNo }}</span
                  >
                </span>
              </span>
            </template>
            <h6 class="dropdown-header">
              {{ this.$t("Welcome") }} {{ this.userFirstName }}
            </h6>
            <b-dropdown-item
              @click="redirectToProfil()"
              link-class="d-flex align-items-center"
            >
              <font-awesome-icon icon="fa-solid fa-circle-user" />

              <span class="text-start ms-xl-2">
                {{ this.$t("ProfileAtilim") }}
              </span>
            </b-dropdown-item>

            <b-dropdown-item
              @click="redirectToPosta()"
              link-class="d-flex align-items-center"
            >
              <font-awesome-icon icon="fa-solid fa-square-envelope" />
              <span class="text-start ms-xl-2"> {{ this.$t("Inbox") }} </span>
            </b-dropdown-item>
            <div class="dropdown-divider"></div>
            <b-dropdown-item link-class="d-flex align-items-center">
              <font-awesome-icon icon="fa fa-sign-out" />
              <span class="text-start ms-xl-2" @click="logout($event)">{{
                this.$t("Logout")
              }}</span>
            </b-dropdown-item>
          </BDropdown>
        </div>
      </div>
    </div>
  </header>
</template>
